import { render, staticRenderFns } from "./register-driver.vue?vue&type=template&id=4c5df7c4"
import script from "./register-driver.vue?vue&type=script&lang=js"
export * from "./register-driver.vue?vue&type=script&lang=js"
import style0 from "./register-driver.vue?vue&type=style&index=0&id=4c5df7c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports